import { render, staticRenderFns } from "./ArrivalQuantity.vue?vue&type=template&id=3549abad&scoped=true&"
import script from "./ArrivalQuantity.vue?vue&type=script&lang=js&"
export * from "./ArrivalQuantity.vue?vue&type=script&lang=js&"
import style0 from "./ArrivalQuantity.vue?vue&type=style&index=0&id=3549abad&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3549abad",
  null
  
)

export default component.exports